import { InjectionToken, Optional, Inject, SkipSelf } from '@angular/core';

export const TOKEN_STORAGE_NAME = new InjectionToken('token.storage');
export const REFRESH_TOKEN_STORAGE_NAME = new InjectionToken('refresh.token.storage');
export const REFRESH_TOKEN_API_URL = 'refresh.token.api.url';

export class ConfigService {

  constructor(
    @Optional()
    @Inject(TOKEN_STORAGE_NAME)
    private tokenStorageName: string,

    @Optional()
    @Inject(REFRESH_TOKEN_STORAGE_NAME)
    private refreshTokenStorageName: string,

    @Optional()
    @Inject(REFRESH_TOKEN_API_URL)
    private refreshTokenApiUrl: string
  ) {
    this.tokenStorageName = this.default<string>(this.tokenStorageName, 'token');
    this.refreshTokenStorageName = this.default<string>(this.refreshTokenStorageName, 'refreshToken');
    this.refreshTokenApiUrl = this.default<string>(this.refreshTokenApiUrl, '');
  }

  public getTokenStorageName(): string {
    return this.tokenStorageName;
  }

  public getRefreshTokenStorageName(): string {
    return this.refreshTokenStorageName;
  }

  public getRefreshTokenApiUrl(): string {
    return this.refreshTokenApiUrl;
  }

  public setRefreshTokenApiUrl(url: string): void {
    this.refreshTokenApiUrl = url;
  }

  private default<T>(variable: T, defaultValue: T): T {
    if (null === variable) {
      return defaultValue;
    }

    return variable;
  }

}
